import { render, staticRenderFns } from "./theme_menu_song.vue?vue&type=template&id=58b1dc6c&scoped=true"
import script from "./theme_menu_song.vue?vue&type=script&lang=js"
export * from "./theme_menu_song.vue?vue&type=script&lang=js"
import style0 from "./theme_menu_song.vue?vue&type=style&index=0&id=58b1dc6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1dc6c",
  null
  
)

export default component.exports